import { Link } from "react-router-dom";
import { useT } from "../i18n/I18nProvider";
import { ChevronRight } from "lucide-react";
import { BLOG_POSTS } from "../data/blogPosts";

export default function Blog() {
  const { lp } = useT();

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-testid="blog-index">
      <header className="mb-12" data-testid="blog-hero">
        <span className="hej-chip" data-testid="blog-chip">
          <span className="w-1.5 h-1.5 rounded-full bg-[#DC143C]"></span>
          Blog
        </span>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mt-4">
          Blog
        </h1>
        <p className="text-slate-600 mt-4 leading-relaxed text-lg">
          Analyses et regards sur l'installation en Pologne, du marché du travail au quotidien des francophones.
        </p>
      </header>

      <ul className="space-y-6 list-none" data-testid="blog-list">
        {BLOG_POSTS.map((post) => (
          <li key={post.slug}>
            <Link
              to={lp(`/blog/${post.slug}`)}
              className="block bg-white border border-slate-200 rounded-2xl p-6 md:p-7 hover:border-[#0056D2] hover:shadow-md transition group"
              data-testid={`blog-card-${post.slug}`}
            >
              <div className="flex items-center gap-2 text-xs font-medium text-slate-500 mb-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#DC143C]"></span>
                {post.dateLabel}
              </div>
              <h2 className="font-display text-xl sm:text-2xl font-semibold text-slate-900 group-hover:text-[#0056D2] transition">
                {post.title}
              </h2>
              <p className="text-slate-600 mt-3 leading-relaxed">{post.excerpt}</p>
              <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-[#0056D2] group-hover:gap-2 transition-all">
                Lire l'article
                <ChevronRight className="w-4 h-4" />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
